import { trackAnalyticsEvent } from '@cof/refi-web-sdk';
import { TagKey } from '@cof/tag-catalog-fs-lienholder-mfe';
import { DebugService } from './debug.service';
import { ApiService } from './api.service';
import { REFI_LIENHOLDER_CONST } from '../constants/app.constants';
import { stratum } from '../../../constants/stratum.js';

class _LenderInfoService {
  _appId: string;
  _lienholderModel: any;
  debug: DebugService;
  constructor() {
    this.debug = new DebugService('LenderService');
    this._appId = '';
    this._lienholderModel = {};
  }

  set vin(vin: any) {
    this._lienholderModel.vin = vin;
  }

  get appId() {
    return this._appId;
  }

  set appId(id) {
    this._appId = id;
  }

  getLienholder() {
    return this._lienholderModel;
  }

  setLienholder(lienholder: any) {
    this._lienholderModel = lienholder;
  }

  set lienholderModel(custDetails: any) {
    this._lienholderModel.lienHolderName = custDetails.lienHolderName
      ? window.atob(custDetails.lienHolderName)
      : '';
    this._lienholderModel.lienHolderAccountNumber =
      custDetails.lienHolderAccountNumber
        ? window.atob(custDetails.lienHolderAccountNumber)
        : '';
  }

  async persistLienHolder(lenderInfo: any, createDocument = true) {
    this.debug.log('persistLienHolder called with', lenderInfo);
    try {
      const body = {
        lienHolderName: lenderInfo.lienHolderName
          ? window.btoa(lenderInfo.lienHolderName)
          : '',
        lienHolderAccountNumber: lenderInfo.lienHolderAccountNumber
          ? window.btoa(lenderInfo.lienHolderAccountNumber)
          : '',
      };
      let url = `${REFI_LIENHOLDER_CONST.LIENHOLDER_BFF_URL}${this._appId}/persist-lienholder`;
      if (!createDocument) {
        url += '?createDocument=false';
      }
      const res = await ApiService.post(
        url,
        body,
        {},
        REFI_LIENHOLDER_CONST.TIMEOUT_IN_MS
      );
      this.debug.log('success in persistLienHolder', res);
      if (createDocument) {
        this.sendCustomerProfileDocAnalytics();
      }
      return res;
    } catch (err) {
      this.debug.log('error in persistLienHolder', err);
      return { isOperationSuccessful: false };
    }
  }

  sendCustomerProfileDocAnalytics() {
    stratum.publishTag(TagKey.CUSTOMER_PROFILE_CUSTOMER_PROFILE_DOC_GENERATED);
    trackAnalyticsEvent('customer profile doc generated');
  }

  async retrieveLienholder() {
    this.debug.log('retrieveLienholder called');
    try {
      const res = await ApiService.get(
        `${REFI_LIENHOLDER_CONST.LIENHOLDER_BFF_URL}${this._appId}/lienholder`,
        {},
        REFI_LIENHOLDER_CONST.TIMEOUT_IN_MS
      );
      this.debug.log('success in retrieveLienholder', res);
      if (res) {
        this._lienholderModel.lienHolderAccountNumber =
          res.lienHolderAccountNumber ? res.lienHolderAccountNumber : null;
        this._lienholderModel.lienHolderName = res.lienHolderName
          ? res.lienHolderName
          : null;
        this._lienholderModel.currentLoanPayOffAmount =
          res.currentLoanPayOffAmount;
      }
      return res;
    } catch (err) {
      this.debug.log('error in retrieveLienholder', err);
      return {};
    }
  }
}

export const LenderService = new _LenderInfoService();
